import {
  Category,
  createCategory,
  createVariantList,
  deleteCategory,
  editCategory,
  getCategory,
  VariantList
} from '@/@core/services/app.service'
import { formatDate } from '@/@core/utils/utils'
import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  TextField
} from '@mui/material'
import { Box } from '@mui/system'
import { Close, Plus } from 'mdi-material-ui'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'

interface NObject {
  [key: string]: any
}

const AddReport = (props: any) => {
  const { t } = useTranslation()
  const [isAdd, setIsAdd] = React.useState(false)
  const [state, setState] = React.useState<NObject>({})
  const [category, setCategory] = React.useState<Category[]>([])
  const [categoryName, setCategoryName] = React.useState<string>('')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked
    })
  }

  const { data, refetch } = useQuery({
    queryFn: () => getCategory(),
    keepPreviousData: true,
    onSuccess: (data) => {
      if (data && data.list) {
        //
        const obj: NObject = {}

        data.list.map((item: { name: any }) => {
          obj[item.name] = false
        })

        setState(obj)

        setCategory(data.list)
      } else {
        setCategory([])

        setState({})
      }
    }
  })

  const addCategory = useMutation({
    mutationFn: async (data: Category) => await createCategory(data),
    onSuccess: (data) => {
      //post返回的结果
      refetch()

      setIsAdd(false)

      setCategoryName('')

      //
    }
  })

  const addVariantList = useMutation({
    mutationFn: async (data: VariantList) => await createVariantList(data),
    onSuccess: (data) => {
      //post返回的结果
      //
    }
  })

  const editCategoryt = useMutation({
    mutationFn: async (data: Category) => await editCategory(data),
    onSuccess: (data) => {
      //post返回的结果
      refetch()

      //
    }
  })

  const deleteCategoryt = useMutation({
    mutationFn: async (data: number) => await deleteCategory(data),
    onSuccess: (data) => {
      //post返回的结果
      refetch()

      //
    }
  })

  return (
    <Box>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t('Add to...')}
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <Close />
      </IconButton>

      <DialogContent dividers sx={{ minWidth: 400, minHeight: 300 }}>
        <FormGroup>
          {category.map((item) => {
            return (
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleChange}
                    checked={state[item.name as string]}
                    name={item.name as string}
                  />
                }
                label={item.name}
              />
            )
          })}
        </FormGroup>
      </DialogContent>

      <DialogActions>
        {isAdd ? (
          <Box width={'100%'} padding={2}>
            <TextField
              fullWidth
              size="small"
              id="outlined-basic"
              label={t('name')}
              variant="outlined"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
            />

            <Grid container justifyContent={'end'} marginTop={'10px'}>
              <Grid item>
                <Button
                  sx={{ marginRight: '10px' }}
                  onClick={() => {
                    setIsAdd(false)
                  }}
                >
                  {t('cancel')}
                </Button>

                <Button
                  variant="contained"
                  onClick={() => {
                    if (categoryName)
                      addCategory.mutateAsync({
                        name: categoryName,
                        userId: null,
                        createdAt: formatDate(new Date()),
                        updatedAt: formatDate(new Date()),
                        isPublic: 1
                      })
                  }}
                  autoFocus
                >
                  {t('create')}
                </Button>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Grid
            container
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Grid item display={'flex'}>
              <Button
                sx={{ margin: '10px 0' }}
                autoFocus
                startIcon={<Plus />}
                onClick={() => {
                  setIsAdd(true)
                }}
              >
                {t('Create a new list')}
              </Button>
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                size="small"
                sx={{ margin: '10px 0' }}
                autoFocus
                onClick={() => {
                  //
                  const list = []

                  Object.getOwnPropertyNames(state).map((key) => {
                    if (state[key]) {
                      const temp = category.find((item) => item.name === key)

                      if (temp) {
                        props.selectRowKey.map((items: any) => {
                          const params: VariantList = {
                            categoryId: temp.id as number,
                            key: items.key,
                            chrom: items.chrom,
                            pos: items.pos,
                            ref: items.REF ?? items.ref,
                            alt: items.ALT ?? items.alt,
                            pnomen: items.p_nomen ?? items.hgvsp,
                            cnomen: items.c_nomen ?? items.hgvsc,
                            gene: items.gene
                          }

                          addVariantList.mutateAsync(params)
                        })
                      }
                    }
                  })

                  props.handleClose()
                }}
              >
                {t('add')}
              </Button>
            </Grid>
          </Grid>
        )}
      </DialogActions>
    </Box>
  )
}

export default AddReport
